import { axios } from '@Root/API'

export const edit = (engagementId, payload) => {
	return axios.put(`student-engagement/${engagementId}/qualification-awarded/${payload.id}`, payload)
}
